import TablePagination from '../component/TablePagination';
import { brand } from "../config/brands";
import React, { useEffect, useState } from 'react';
import Layout from '../component/Layout';
import { ArrowUpTrayIcon,  EllipsisVerticalIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { getDriverHistory, getDrivers,getOrdersByDriver } from '../adapter/api';
import { ApiUrlService } from '../api-library/api-services';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import DatePicker from 'react-datepicker';
import './OrderModals.css';

const Drivers = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ordersModalOpen, setOrdersModalOpen] = useState(false);
  const [isModalAddOpen, setIsModalAddOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [firstName, setFirstName]= useState(null);
  const [lname, setLname]= useState(null);
  const [phoneNumber, setPhoneNumber]= useState(null);
  const [password, setPassword]= useState(null);
  const [motoType, setMotoType]= useState(null);
  const apiUrlService = new ApiUrlService()
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isViewOrdersModalOpen, setIsViewOrdersModalOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalOrders, setTotalOrders] = useState(0);


  const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);
  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);

  const getStatusClass = (status) => {
    switch (status) {
      case 'Online':
        return 'bg-lightGreen text-green'; 
      default:
        return 'bg-lightRed text-red'; 
    }
  };


  




  const handleGetCustomers = async () => {
    setCustomers([]);
    const response = await getDrivers()
    setCustomers(response.data.data)
  }


  useEffect(() => {
    handleGetCustomers()
  }, []);

  useEffect(() => {
    if (selectedCustomer) {
      setFirstName(selectedCustomer.first_name || "");
      setLname(selectedCustomer.last_name || "");
      setPhoneNumber(selectedCustomer.phoneNumber || "");
      setMotoType(selectedCustomer.moto_type || "");
      setPassword(selectedCustomer.password || "");
    }
  }, [selectedCustomer]);

  // Inside the component function
const exportToPDF = () => {
  const doc = new jsPDF();
  
  // Adding title to PDF
  doc.text("Drivers", 20, 20);
  
  // Set up headers for the table
  const headers = ["#", "First Name", "Last Name", "Phone No.", "Vehicle Type", "Password" ];
  
  // Create rows dynamically based on orders
  const rows = paginatedOrders.map(order => [
    order.driver_Id,
    order.first_name,
    order.last_name,
    order.phoneNumber,
    order.moto_type,
    order.password
  ]);
  
  // Add the table to the PDF
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 30, // The Y position where the table starts
  });

  // Save the PDF to the local system
  doc.save("drivers.pdf");
};


   // Derived states
   const filteredOrders = customers.filter((order) => {
    const search = searchTerm.toLowerCase();
    return (
      order.first_name?.toString().toLowerCase().includes(search) ||
      order.last_name?.toLowerCase().includes(search) ||
      order.phoneNumber?.toString().toLowerCase().includes(search) ||
      order.moto_type?.toString().toLowerCase().includes(search) ||
      order.password?.toString().toLowerCase().includes(search) 
    );
  });

  const formatDate = (value) => {
    const current = new Date(value);
    return current.toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };
  
  const closeModalOrders = () =>{
    setIsViewOrdersModalOpen(false)
    setOrders([])
    setStartDate(null)
    setEndDate(null)
    setTotalOrders(0)
  }

  const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleEditItem = (driver) => {
    const body =
    {
        "first_name": firstName,
        "last_name":lname,
        "password": password,
        "moto_type": motoType,
        "phoneNumber":phoneNumber
    }
    var service = apiUrlService.PutApi(body)
    fetch(`${brand.apiBaseUrl}/drivers/` + driver.driver_Id + '', service).then((response) => response.json())
        .then((response) => {
            if (response.status === true) {
                toast.success('Driver Updated Successfully');
              setIsModalOpen(false)
              handleGetCustomers()
              setFirstName("")
              setLname("")
              setPassword("")
              setMotoType("")
              setPhoneNumber("")
        

            }
        })
  };

  const handleSaveItem = () => {
   

    const user = {
      email: null,
      phoneNumber:phoneNumber,
      firstName:firstName +' '+ lname,
      lastName:null,
      roles:{
          role_id: "4"
      }
    };

    var service2 = apiUrlService.PostApi(user)


      fetch(`${brand.identityApiUrl}/user/save`, service2).then((response) => response.json())
              .then(async (resp) => {
                if(resp.status == 500){
                  toast.error("Number already Exist!")
                }else{

                  alert(resp.data.user_id)
                  const body =
                  {
                      "first_name": firstName,
                      "last_name":lname,
                      "password": resp.data.pass,
                      "moto_type": motoType,
                      "phoneNumber":phoneNumber,
                      "driver_Id": resp.data.user_id
                  }
                  var service = apiUrlService.PostApi(body)
                  fetch(`${brand.apiBaseUrl}/drivers/`, service).then((response) => response.json())
                      .then((response) => {
                          if (response.status === true) {
                              toast.success('Driver Added Successfully');
                            setIsModalAddOpen(false)
                            handleGetCustomers()
                            setFirstName("")
                            setLname("")
                            setPassword("")
                            setMotoType("")
                            setPhoneNumber("")
                      
              
                          }
                      })
                }})
    
  };

  const handleDeleteClick = (item) => {
    toggleDropdown(null)
    setSelectedItem(item);
    setShowConfirmModal(true);
  }

  const cancelDelete = () => {
    setShowConfirmModal(false);
  };

  const confirmDelete = () => {
   
    handleDeleteDriver(selectedItem);
  
  };

  const handleDeleteDriver = async (driver) =>{
    try {

      var service = apiUrlService.DeleteApi();
      fetch(`${brand.apiBaseUrl}/drivers/` + driver.driver_Id + '', service).then(res => res.json())
          .then(response => {
 
              if (response.status === true) {
                toast.success("Driver Deleted!");
                  setShowConfirmModal(false);
                 
                  handleGetCustomers()
              }else{
       
                toast.error("Error deleting category!");
              
              
              }
          })


    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  }



  const handleDeleteItem = (index) => {
    console.log("Delete item at index:", index);
    // Implement the logic to delete the item
    // For example, you can update the items array:
    const updatedItems = selectedCustomer.items.filter((_, i) => i !== index);
    setSelectedCustomer({ ...selectedCustomer, items: updatedItems });
  };


  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedCustomer(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  const viewOrders = async (order) => {
    toggleDropdown(null)
    setSelectedCustomer(order); // Set the selected order to display its details
    const response = await getOrdersByDriver(order.driver_Id)
    setOrders(response.data.data)
    setOrdersModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalAddOpen(false)
    setSelectedCustomer(null); // Clear selected order when closing the modal
    setFirstName("")
    setLname("")
    setPassword("")
    setMotoType("")
    setPhoneNumber("")

  };

  //Driver Order History

  const handleViewOrders = (driver) => {
    // Open the modal
    toggleDropdown(null)
    setSelectedCustomer(driver)
    setIsViewOrdersModalOpen(true);
  };  
  
  const fetchOrders = async () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }

    try {
         // Convert dates to yyyy-MM-dd format
    const formattedStartDate = dayjs(startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(endDate).format("YYYY-MM-DD");
     
    const response = await getDriverHistory(formattedStartDate,formattedEndDate,selectedCustomer.driver_Id)

      setOrders(response.data.data);
      setTotalOrders(response.data.data.length);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };


  return (
    <Layout>
              <ToastContainer />
      <h1 className="text-2xl font-medium mb-4 mt-7 font-inter text-lg">Drivers</h1>
      {/* Page content goes here */}
      <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

      <div className="data-card overflow-x-auto mt-4 rounded-lg">
        <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
          <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search drivers…" aria-label="Search drivers"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
          </div>

          <div className="npb-3 flex">
            <button onClick={() => setIsModalAddOpen(true)}
              className="mr-5 px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <PlusIcon className="h-4 w-4 mr-2 mt-0.4" />
              New Driver
            </button>
            <button onClick={exportToPDF}
              className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
              Export
            </button>
          </div>
        </div>
        <table className="data-table  min-w-full bg-white border-b border-r border-l border-gray-200 shadow-sm">
          <thead>
            <tr className="bg-grey border-b">
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700"></th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">First Name</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Last Name</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Phone Number</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Password</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Vehicle Type</th>
              <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Status</th>
            </tr>
          </thead>
          <tbody>
            {paginatedOrders.map((order) => (
              <tr
                key={order.driver_Id}
                className="border-b hover:bg-gray-50"
              >
                <td
                  className="px-4 py-3 text-sm text-yellow font-inter cursor-pointer"
                 
                >
                  <EllipsisVerticalIcon className="h-5 w-5 mr-2" 
                   onClick={() => toggleDropdown(order.driver_Id)} />
                   {dropdownOpenId === order.driver_Id && (
                     <div className="absolute bg-white shadow rounded p-2" style={{ width: "10%" }}>
                       <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={() => openModal(order)}>Edit</button>
                       <hr className="w-full border-gray-200 my-2" />
                       <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={()=> handleViewOrders(order)}>View Orders</button>
                       <hr className="w-full border-gray-200 my-2" />
                       <button className="block w-full text-left px-2 py-1 text-red-600 hover:text-yellow text-gray-700" onClick={() => handleDeleteClick(order)}>Delete</button>
                     </div>
                   )}
                </td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.first_name}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.last_name}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.phoneNumber}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.password}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.moto_type}</td>
                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">
                <span className={`px-2 py-1 font-inter font-medium rounded-full text-sm ${getStatusClass(order.status_name)}`}>
                    {order.status_name}
                  </span></td>
              </tr>
            ))}

          </tbody>
        </table>
        {/* Pagination */}
      <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      <div className="data-endcap">
       
      
        {/* Modal */}
        {isModalOpen && selectedCustomer && (
          <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="order-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">Driver Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

              {/* Other Order Details */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />

<label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={lname}
                  onChange={(e) => setLname(e.target.value)}
                />

               

                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />

<label className="block text-sm font-medium text-gray-700 mb-1">Vehicle Type</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={motoType}
                  onChange={(e) => setMotoType(e.target.value)}
                />


              </div>





              <div className="flex justify-center space-x-2">
                <button
                  className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white "
                  onClick={() => handleEditItem(selectedCustomer)}
                >
                  SAVE
                </button>
                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        )}


{isModalAddOpen  && (
          <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="order-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">Driver Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

              {/* Other Order Details */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />

<label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={lname}
                  onChange={(e) => setLname(e.target.value)}
                />

                

                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />

<label className="block text-sm font-medium text-gray-700 mb-1">Vehicle Type</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={motoType}
                  onChange={(e) => setMotoType(e.target.value)}
                />


              </div>





              <div className="flex justify-center space-x-2">
                <button
                  className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white "
                  onClick={() => handleSaveItem()}
                >
                  SAVE
                </button>
                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Confirmation Modal */}
        {showConfirmModal && (
        <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="order-dialog-panel bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this driver?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                onClick={cancelDelete}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

 {/* View Orders Modal */}
 {isViewOrdersModalOpen && (
        <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="order-modal-panel bg-white rounded-lg shadow-lg p-6">
            <h2 className="text-lg font-semibold mb-4">Select Dates to View Orders</h2>

            <div className="flex gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  dateFormat="yyyy-MM-dd"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  dateFormat="yyyy-MM-dd"
                />
              </div>
              <div className='mt-6'>

              <button
              onClick={fetchOrders}
              className=" w-full px-4 py-2  bg-blue-600 text-yellow border border-yellow rounded-lg hover:text-white hover:bg-yellow"
            >
              Fetch Orders
            </button>
            </div>
            </div>

           

            <div className="mt-4">
              <h3 className="text-md font-semibold">Orders</h3>
              <div className="data-scroll overflow-x-auto"><table className="data-table w-full mt-2 border">
                <thead>
                  <tr>
                    <th className="border px-4 py-2">Order ID</th>
                    <th className="border px-4 py-2">Date</th>
                    <th className="border px-4 py-2">Customer</th>
                    <th className="border px-4 py-2">Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order.id}>
                      <td className="border px-4 py-2">{order.order.orderNumber}</td>
                      <td className="border px-4 py-2">{order.order.dateCreated}</td>
                      <td className="border px-4 py-2">{order.order.customer.firstName}</td>
                      <td className="border px-4 py-2">{order.order.totalAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table></div>
              <p className="mt-2">Total Orders: {totalOrders}</p>
            </div>

            <div className="flex justify-end">
  <button
    onClick={() => closeModalOrders()}
    className="mt-4 px-4 py-2 bg-red-600 text-gray-800 rounded-lg"
  >
    Close
  </button>
</div>
          </div>
        </div>
      )}
      </div>
    </Layout>
  );
};

export default Drivers;
